import http from './http'
let url = 'UnimedBelem/'

export function gerarEventoAutomatico(chaveDivida, parcela){
    return http.get(`${url}/GerarEventoAutomatico/${chaveDivida}/${parcela}`)
}